import { render, staticRenderFns } from "./SchoolCardTemp.vue?vue&type=template&id=140a2ec5&"
import script from "./SchoolCardTemp.vue?vue&type=script&lang=js&"
export * from "./SchoolCardTemp.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCardTemp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports